import {
  SecCallbackActions,
  SetInputValidated,
  SET_INPUT_SEC_CALL_BACK,
  SET_FORM_LOADING_SEC_CALL_BACK,
  SetFormLoading,
  SET_PHONE_INPUT_SEC_CALL_BACK,
  SetPhoneInputValidated,
  SET_FORM_SUCCESS_SEC_CALL_BACK,
  SetFormSuccess,
  SetGeneralErrorMessage,
  SET_GENERAL_ERROR_SEC_CALLBACK,
  RESET_FORM_SEC_CALL_BACK,
} from 'src/application/lazy/sec-callback/actions';

export type SecCallbackData = {
  isLoading: boolean;
  isSuccess: boolean;
  generalError: {
    message?: string;
  };
  accountNumber: {
    value: string;
    error: string;
  };
  recaptcha: {
    value: string;
    error: string;
  };
  name: {
    value: string;
    error: string;
  };
  phoneNumber: {
    countryCode: string;
    number: string;
    error: string;
  };
  email: {
    value: string;
    error: string;
  };
}

export const initialState: SecCallbackData = {
  isLoading: false,
  isSuccess: false,
  generalError: {
    message: '',
  },
  accountNumber: {
    value: '',
    error: '',
  },
  recaptcha: {
    value: '',
    error: '',
  },
  name: {
    value: '',
    error: '',
  },
  phoneNumber: {
    countryCode: '+971',
    number: '',
    error: '',
  },
  email: {
    value: '',
    error: '',
  },
};

const secCallbackReducer = (
  state: SecCallbackData = initialState,
  action: SecCallbackActions,
): SecCallbackData => {
  switch (action.type) {
    case SET_INPUT_SEC_CALL_BACK:
      return {
        ...state,
        ...(action as SetInputValidated).payload,
      };
    case SET_PHONE_INPUT_SEC_CALL_BACK:
      return {
        ...state,
        ...(action as SetPhoneInputValidated).payload,
      };
    case SET_FORM_LOADING_SEC_CALL_BACK: {
      return {
        ...state,
        isLoading: (action as SetFormLoading).payload.isLoading,
      };
    }
    case SET_FORM_SUCCESS_SEC_CALL_BACK: {
      return {
        ...state,
        isSuccess: (action as SetFormSuccess).payload.isSuccess,
      };
    }
    case SET_GENERAL_ERROR_SEC_CALLBACK: {
      return {
        ...state,
        generalError: {
          message: (action as SetGeneralErrorMessage).payload,
        },
      };
    }
    case RESET_FORM_SEC_CALL_BACK: {
      return initialState;
    }
    default:
      return state;
  }
};

export default secCallbackReducer;
